export default __webpack_public_path__ + "static/media/walden-express.65062ba2.svg";